import graphql__5637a9029650682841ca from "./__generated__/ContributionsListWithNavigationFragment_participativeModule.graphql.js";import { graphql } from "react-relay";

// This fragment is used to refetch filtered data for contributions list with navigation
// to ensure that both the navigation cards and the list contributions details are
// actually reloaded when the connection is refetched after filters are changed
//
export const ContributionsListWithNavigationFragment_participativeModule = graphql__5637a9029650682841ca;
